import Gateway from '@/utils/Gateway';

// 获取绑定状态和企业微信账号信息
export default function getBindInfo() {
    return new Promise((resolve, reject) => {
        Gateway.get('/v1/corp/wework/CorpInfo')
            .then(data => {
                // status 0为已绑定 1为未绑定
                const { status } = data || {};
                let isBind = false;
                let bindInfo = {};

                if (status === 0) {
                    isBind = true;
                    bindInfo = data || {};

                    // 旧企业使用通讯录参数配置 新企业使用代开发应用
                }

                bindInfo.isParamsContact = !bindInfo.is_new;

                resolve({
                    isBind,
                    bindInfo
                });
            })
            .catch(e => {
                reject(e);
            });
    });
}
